// Deletesupplier.tsx
import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { KTSVG } from '../../../_metronic/helpers';

interface DeletesupplierProps {
  show: boolean;
  handleClose: () => void;
  deleteselectedsupplier: () => void;
  suppliertodelete: any;
  statedeletingsupplier: boolean;
  cannotDeletesupplier: boolean;
}

const Deletesupplier: FC<DeletesupplierProps> = ({
  show,
  handleClose,
  deleteselectedsupplier,
  suppliertodelete,
  statedeletingsupplier,
  cannotDeletesupplier,
}) => {
  return (
    <Modal
      className='modal fade'
      id='kt_modal_delete_supplier'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>Delete Supplier
          <span className='h-10px border-gray-200 border-start mx-2'></span>
          <span className='text-muted fw-bold fs-6'>{suppliertodelete.supplier_id}</span>
          </h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='fv-row mb-7'>
            <div className='card bg-light'>
              {/* begin::Header */}
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='required card-label fw-bolder fs-5 mb-1'>Supplier Details</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    Review supplier information before deletion
                  </span>
                </h3>
              </div>
              {/* end::Header */}
              {/* begin::Body */}
              <div className='card-body py-3'>
                <div className='row'>
                  <div className='col-lg-6 fv-row mb-7'>
                    <label className='fw-bold fs-6 mb-2'>First Name</label>
                    <div>
                      <span className='text-dark fw-bold fs-6'>
                        {suppliertodelete.supplier_firstname || 'N/A'}
                      </span>
                    </div>
                  </div>

                  <div className='col-lg-6 fv-row mb-7'>
                    <label className='fw-bold fs-6 mb-2'>Second Name</label>
                    <div>
                      <span className='text-dark fw-bold fs-6'>
                        {suppliertodelete.supplier_secondname || 'N/A'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-lg-6 fv-row mb-7'>
                    <label className='fw-bold fs-6 mb-2'>Phone Number</label>
                    <div>
                      <span className='text-dark fw-bold fs-6'>
                        {suppliertodelete.supplier_phone_number || 'N/A'}
                      </span>
                    </div>
                  </div>

                  <div className='col-lg-6 fv-row mb-7'>
                    <label className='fw-bold fs-6 mb-2'>Email</label>
                    <div>
                      <span className='text-dark fw-bold fs-6'>
                        {suppliertodelete.supplier_email || 'N/A'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* end::Body */}
            </div>
          </div>

          {/* Warning message */}
          {cannotDeletesupplier && (
            <div className='fv-row mb-7'>
              <div className='alert alert-danger d-flex align-items-center p-5'>
                <KTSVG
                  path='/media/icons/duotune/general/gen044.svg'
                  className='svg-icon-2hx svg-icon-danger me-4'
                />
                <div className='d-flex flex-column'>
                  <span className='fw-bold fs-6'>
                    Cannot delete supplier. There may be associated purchases or other dependencies.
                  </span>
                </div>
              </div>
            </div>
          )}

          <span className='required fw-bold fs-5 mb-2'>
            Are you sure you want to delete the above supplier?
          </span>

        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={handleClose}>
            Cancel
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-danger'
            onClick={deleteselectedsupplier}
            disabled={statedeletingsupplier || cannotDeletesupplier}
          >
            {!statedeletingsupplier && <span className='indicator-label'>Delete Supplier</span>}
            {statedeletingsupplier && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export { Deletesupplier };